import { useMemo } from 'react'
import { useSpaceManagement } from './useSpaceManagement'
import { evaluateQuickFit } from '@/lib/quick-fit'
import type { FitAircraftDims, QuickFitResult } from '@/types/quick-fit'

/**
 * Hook combining space management data with the quick fit algorithm.
 * Accepts normalized aircraft dimensions from any source
 * (aircraft type catalog or individual aircraft record).
 */
export function useQuickFit(
  locationId: string | null,
  dims: FitAircraftDims | null,
  displayName: string
): { result: QuickFitResult | null; isLoading: boolean } {
  const { data: areas, isLoading } = useSpaceManagement(locationId)

  const result = useMemo(() => {
    if (!areas || !dims) return null
    return evaluateQuickFit(areas, dims, displayName)
  }, [areas, dims, displayName])

  return { result, isLoading }
}
